export enum Permission {
  CHANGE_PASSWORD = 'changePassword',
  CREATE_PROJECT = 'createProject',
  CREATE_USER = 'createUser',
  DOWNLOAD_TRACERS = 'downloadTracers',
  READ_ORGANIZATION_KEYS = 'readOrganizationKeys',
  READ_ORGANIZATION_CERTIFICATES = 'readOrganizationCertificates',
  READ_ORGANIZATION_USERS = 'readOrganizationUsers',
  READ_ORGANIZATION_SCANS = 'readOrganizationScans',

  UPDATE_PROJECT = 'updateProject',
  DELETE_PROJECT = 'deleteProject',
  CREATE_SLOT = 'createSlot',
  UPLOAD_TRACE = 'uploadTrace',
  CREATE_EXCEPTIONS = 'createExceptions',

  UPDATE_SLOT = 'updateSlot',
  DELETE_SLOT = 'deleteSlot',

  UPDATE_USER_NAME = 'updateUserPreferredName',
  UPDATE_USER_PERMISSIONS = 'updateUserPermissions',
  UPDATE_USER_AUTH_TAGS = 'updateUserAuthTags',
  DELETE_USER = 'deleteUser',
  RESET_USER_PASSWORD = 'resetUserPassword',

  CREATE_PROFILE = 'createProfile',
  UPDATE_PROFILE = 'updateProfile',
  DELETE_PROFILE = 'deleteProfile',

  CREATE_SCAN = 'createScan',
  UPDATE_SCAN = 'updateScan',
  DELETE_SCAN = 'deleteScan',

  CROWDSTRIKE_EDIT_CONFIG = 'crowdStrikeEditConfig',
  CROWDSTRIKE_QUERY_HOSTS = 'crowdStrikeQueryHosts',
  CROWDSTRIKE_UPLOAD_FILES_STORAGE = 'crowdStrikeUploadFilesToStorage',
  CROWDSTRIKE_UPLOAD_SCRIPTS_STORAGE = 'crowdStrikeUploadScriptsToStorage',
  CROWDSTRIKE_RUN_SCRIPTS_HOSTS = 'crowdStrikeRunScriptsOnHosts',
  CROWDSTRIKE_UPLOAD_FILES_HOSTS = 'crowdStrikeUploadFilesToHosts',
  CROWDSTRIKE_READ_FILES_HOSTS = 'crowdStrikeReadFilesFromHosts',

  JIRA_EDIT_CONFIG = 'jiraEditConfig',
  JIRA_EDIT_PROJECT_CONFIG = 'jiraEditProjectConfig',
  JIRA_EXPORT_INSTANCES = 'jiraExportInstances',

  SERVICENOW_EDIT_CONFIG = 'serviceNowEditConfig',
  SERVICENOW_CHECK_CONNECTION = 'serviceNowCheckConnection',
  SERVICENOW_EXPORT_INSTANCES = 'serviceNowExportInstances',

  TANIUM_EDIT_CONFIG = 'taniumEditConfig',
  TANIUM_EDIT_PROJECT_CONFIG = 'taniumEditProjectConfig',
  TANIUM_CHECK_CONNECTION = 'taniumCheckConnection',

  VENAFI_EDIT_CONFIG = 'venafiEditConfig',
  VENAFI_CHECK_CONNECTION = 'venafiCheckConnection',
  VENAFI_POPULATE_GUIDS = 'venafiPopulateGuids',
  VENAFI_CERTIFICATE_DETAILS = 'venafiGetCertificateDetails',
  VENAFI_CERTIFICATE_UPLOAD = 'venafiUploadCertificate',
}

export const GENERIC_PERMISSIONS = [
  Permission.CHANGE_PASSWORD,
  Permission.CREATE_PROJECT,
  Permission.CREATE_USER,
  Permission.CREATE_PROFILE,
  Permission.CREATE_SCAN,
  Permission.DOWNLOAD_TRACERS,
  Permission.READ_ORGANIZATION_KEYS,
  Permission.READ_ORGANIZATION_CERTIFICATES,
  Permission.READ_ORGANIZATION_USERS,
  Permission.READ_ORGANIZATION_SCANS,
];

export const INTEGRATION_PERMISSIONS = [
  Permission.CROWDSTRIKE_EDIT_CONFIG,
  Permission.CROWDSTRIKE_QUERY_HOSTS,
  Permission.CROWDSTRIKE_UPLOAD_FILES_STORAGE,
  Permission.CROWDSTRIKE_UPLOAD_SCRIPTS_STORAGE,
  Permission.CROWDSTRIKE_RUN_SCRIPTS_HOSTS,
  Permission.CROWDSTRIKE_UPLOAD_FILES_HOSTS,
  Permission.CROWDSTRIKE_READ_FILES_HOSTS,
  Permission.JIRA_EDIT_CONFIG,
  Permission.JIRA_EXPORT_INSTANCES,
  Permission.SERVICENOW_EDIT_CONFIG,
  Permission.SERVICENOW_CHECK_CONNECTION,
  Permission.SERVICENOW_EXPORT_INSTANCES,
  Permission.TANIUM_EDIT_CONFIG,
  Permission.TANIUM_CHECK_CONNECTION,
  Permission.VENAFI_EDIT_CONFIG,
  Permission.VENAFI_CHECK_CONNECTION,
];

export const PROJECT_PERMISSIONS = [
  Permission.UPDATE_PROJECT,
  Permission.DELETE_PROJECT,
  Permission.CREATE_SLOT,
  Permission.UPLOAD_TRACE,
  Permission.CREATE_EXCEPTIONS,
  Permission.JIRA_EDIT_PROJECT_CONFIG,
  Permission.TANIUM_EDIT_PROJECT_CONFIG,
];

export const SLOT_PERMISSIONS = [Permission.UPDATE_SLOT, Permission.DELETE_SLOT];

export const REPORT_PERMISSIONS = [Permission.VENAFI_POPULATE_GUIDS];

export const CERTIFICATE_PERMISSIONS = [Permission.VENAFI_CERTIFICATE_DETAILS, Permission.VENAFI_CERTIFICATE_UPLOAD];

export const PROFILE_PERMISSIONS = [Permission.UPDATE_PROFILE, Permission.DELETE_PROFILE];

export const USER_PERMISSIONS = [
  Permission.UPDATE_USER_NAME,
  Permission.UPDATE_USER_PERMISSIONS,
  Permission.UPDATE_USER_AUTH_TAGS,
  Permission.DELETE_USER,
  Permission.RESET_USER_PASSWORD,
];

export const SCAN_PERMISSIONS = [Permission.UPDATE_SCAN, Permission.DELETE_SCAN];
